/*
  Product page helpers (canvasbynumbers.es). Loaded from snippets/product-block-title.liquid.

  Keep the photo upload button (UploadKit app) when the shopper changes size.
  On every variant change the theme swaps the whole option picker for a fresh
  copy from the server (assets/product.js), which throws away anything an app
  placed inside it. The upload button lives there, so it vanished. This puts the
  same button back in the same spot, with any photo already chosen.
*/
(function () {
  if (window.cbnKeepUploadInit) { return; }
  window.cbnKeepUploadInit = true;

  var indexOf = Array.prototype.indexOf;

  function snapshot() {
    var saved = [];
    document.querySelectorAll('.product-variant-selector .uploadkit-injected').forEach(function (node) {
      var selector = node.closest('.product-variant-selector');
      var wrapper = node.closest('.product-option-wrapper');
      var parent = node.parentNode;
      saved.push({
        node: node,
        form: node.closest('form'),
        wrapperIndex: wrapper ? indexOf.call(selector.querySelectorAll('.product-option-wrapper'), wrapper) : -1,
        inWrapper: parent === wrapper,
        childIndex: indexOf.call(parent.children, node)
      });
    });
    return saved;
  }

  function restore(item) {
    var form = item.form && document.contains(item.form) ? item.form : document.querySelector('.product-content form');
    var selector = form ? form.querySelector('.product-variant-selector') : null;
    if (!selector) { return false; }
    if (selector.querySelector('.uploadkit-injected')) { return true; }
    var wrappers = selector.querySelectorAll('.product-option-wrapper');
    var parent = item.inWrapper && wrappers[item.wrapperIndex] ? wrappers[item.wrapperIndex] : (selector.querySelector('.product-options') || selector);
    parent.insertBefore(item.node, parent.children[item.childIndex] || null);
    return true;
  }

  window.addEventListener('variantChange.ecomify.product', function () {
    var saved = snapshot();
    if (!saved.length) { return; }
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      saved = saved.filter(function (item) {
        if (document.contains(item.node)) { return true; }
        return !restore(item);
      });
      var waiting = saved.some(function (item) { return document.contains(item.node); });
      if ((!saved.length) || tries > 60 || (!waiting && tries > 60)) { clearInterval(timer); }
    }, 200);
  });
})();

/*
  Keep the round "back to top" button clear of the sticky add-to-cart bar.
  Both sit at the bottom of the screen, so the button covered the bar's button
  on phones. While the bar shows (#sticky-atc.show) the button is lifted just
  above it (rule in assets/cbn-product.css). The bar's height is measured,
  because it changes with the product title length.
*/
(function () {
  if (window.cbnBackToTopOffset) { return; }
  window.cbnBackToTopOffset = true;

  function start() {
    var bar = document.getElementById('sticky-atc');
    if (!bar) { return; }
    var root = document.documentElement;
    function update() {
      root.style.setProperty('--cbn-sticky-atc-h', bar.offsetHeight + 'px');
      root.classList.toggle('cbn-sticky-atc-on', bar.classList.contains('show'));
    }
    update();
    new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['class'] });
    if ('ResizeObserver' in window) { new ResizeObserver(update).observe(bar); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();
